// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
// import MintUI from 'mint-ui';
import 'mint-ui/lib/style.min.css';
import Bus from './common/js/bus';
import axios from 'axios';
import '../static/css/reset.css'
import '../static/js/rem.js'
import VueClipboard from 'vue-clipboard2'
import {
  Lazyload
} from "vant";
Vue.use(Lazyload, {
  // loading: '../static/img/loading-grey.png'
});
Vue.use(VueClipboard)
Vue.config.productionTip = false;
Vue.tokenUseFlag = false;

// if (process.env.NODE_ENV === "production") {
//   Vue.prototype.baseurl = "https://app.jegotrip.com.cn";           //正式环境
// } else {
//  Vue.prototype.baseurl = "https://test01.jegotrip.com.cn";       //集成环境 (本地环境与测试环境都是这个接口)
// }

//
// // 分享操作
// Vue.prototype._ReParams = function (params) {
//     var t = this;
//     console.log("ReParams")
//     if (!params) params = {};
//     params.activity_id = t._getAPPParams().activity_id;
//     return params;
// }
// Vue.prototype._activity = function (m, d, params = {}) {
//     var t = this;
//     params = t._ReParams(params);
//     return new Promise((resolve, reject) => {
//         var url = t.baseurl + prefix + "m=" + m + "&do=" + d;
//         params.r = "activity";
//         axios.post(url, params).then(
//             res => {
//                 console.log(`${url} params`, params);
//                 console.log(`${url} res`, res);
//                 if (res.status == 200) {
//                     resolve(res.data);
//                 } else {
//                     reject(res.statusText);
//                 }
//             },
//             rej => {
//                 reject(rej);
//                 console.log(rej);
//             }
//         );
//     });
// };
// Vue.prototype._wxReadySuccessFun = function () {
//     var t = this;
//     var userid = 0;
//     var app_login_user = localStorage.getItem(config.login_key);
//     console.log("app:app_login_user");
//     console.log(app_login_user);
//     if (app_login_user) app_login_user = JSON.parse(app_login_user);
//     if (app_login_user && app_login_user.userid) {
//         userid = app_login_user.userid;
//     }
//     var initurl = t._getInitUrl();
//
//     // var myurl = `${initurl.href}?a=${
//     //   initurl.urldata.a ? initurl.urldata.a : 2
//     // }&sid=${userid}&isauth=1`;
//     var myurl =  location.href
//
//     var share_params = {
//         title: title,
//         link: myurl,
//         // imgUrl:"http://test01.jegotrip.com.cn/wyx/appwap/images/logoWhite.png",
//         imgUrl: `${initurl.roothref}icon_share.png`
//     };
//     console.log("share_params", share_params);
//     wx.updateAppMessageShareData({
//         title: share_params.title, // 分享标题
//         link: share_params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//         desc: "我已经领取了，也送你一份。", // 分享描述
//         imgUrl: share_params.imgUrl, // 分享图标
//         success: function () {
//             // 设置成功
//             console.log("updateAppMessageShareData success ");
//         },
//         fail: function (res) {
//             console.log("updateAppMessageShareData fail ", res);
//         }
//     });
//     wx.updateTimelineShareData({
//         title: share_params.title, // 分享标题
//         link: share_params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//         imgUrl: share_params.imgUrl, // 分享图标
//         success: function () {
//             // 设置成功
//             console.log("updateTimelineShareData success ");
//         },
//         fail: function (res) {
//             console.log("updateTimelineShareData fail ", res);
//         }
//     });
// };
// //获得微信sdk配置
// Vue.prototype._getJSConfig = function () {
//     var t = this;
//     console.log("getjsconfig t.urldata", t.urlData);
//     // var url = window.location.href;
//     // var url2 = "",
//     //   url3 = "";
//     // if (url.indexOf("?") >= 0) {
//     //   url2 = url.substring(0, url.indexOf("?"));
//     // }
//     // if (url.lastIndexOf("#") >= 0) {
//     //   url3 = url.substring(0, url.lastIndexOf("#"));
//     // }
//     var initurl = t._getInitUrl();
//     console.log("initurl", initurl);
//     var apilist = ["updateAppMessageShareData", "updateTimelineShareData"];
//     // 记录进入app时的url
//     if (typeof window.entryUrl === "undefined" || window.entryUrl === "") {
//         window.entryUrl = location.href.split("#")[0];
//     }
//     // 进行签名的时候  Android 不用使用之前的链接， ios 需要
//     let signLink = /(Android)/i.test(navigator.userAgent)
//         ? location.href.split("#")[0]
//         : window.entryUrl;
//     var params = {
//         js_config: {
//             jsApiUrl: signLink,
//             jsApiList: apilist
//         }
//     };
//
//     t._activity("activity", "Activity.getJSConfig", params)
//         .then(res => {
//             console.log("***微信sdk配置***");
//             if (res.status == 0 && res.data && res.data.code == "0") {
//                 var res = res.data.body;
//                 wx.config({
//                     debug: false, // 开启调试模式,
//                     appId: res.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
//                     timestamp: res.timestamp, // 必填，生成签名的时间戳
//                     nonceStr: res.nonceStr, // 必填，生成签名的随机串
//                     signature: res.signature, // 必填，签名，见附录1
//                     jsApiList: apilist // 必填，需要使用的JS接口列表，所有JS接口列表见附录2 scanQRCode
//                 });
//                 // var shareInfo = t.shareInfo;
//                 // var title = shareInfo.shareTitle ? encodeURIComponent(shareInfo.shareTitle) : '无忧行邀您组队瓜分百分红包'
//                 wx.ready(function () {
//                     // t.wx_success = 1;
//                     console.log("wxsdk success");
//                     t._wxReadySuccessFun();
//                 });
//                 wx.error(function (res) {
//                     console.log("wxsdk error", res);
//                     // t.wx_success = 0;
//                     // Toast("扫码组件加载失败，请刷新后重试");
//                 });
//             }
//         })
//         .catch(error => {
//             console.log(`error:${error}`);
//         });
//
// };
//获得通用的APP参数
// Vue.prototype._getBrowser = function () {
//     var result = 0;
//     var userAgent = window.navigator.userAgent.toLowerCase();
//     if (userAgent.match(/jegotrip/i) == "jegotrip") result = 1;
//     else if (userAgent.match(/micromessenger/i) == "micromessenger") result = 2;
//     return result;
// };




/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  data: {
    Bus,
  },
  components: { App },
  router,
});

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})



// WEBPACK FOOTER //
// ./src/main.js